import type { DateTimeFilter } from '~/presentation/ui';

import { usePageAnalyticFilterStore } from '../stores/page-analytic-filter';
import { useMetricsTimeFilter } from '~/modules/analytics';
import { useEffect } from 'react';

export const useDateTimeFilter = (isSaveDateTimeToLocalStorage = true) => {
  const { currentDates } = useMetricsTimeFilter();
  const setDateTimePicked = usePageAnalyticFilterStore((state) => state.setDateTimePicked);

  useEffect(() => {
    if (!isSaveDateTimeToLocalStorage) return;

    const dateTimePicked = currentDates as unknown as DateTimeFilter;
    setDateTimePicked({
      since: dateTimePicked.since,
      until: dateTimePicked.until,
      title: dateTimePicked.title,
      alias: dateTimePicked.alias,
    });
  }, [currentDates, isSaveDateTimeToLocalStorage]);
};
